import React from 'react';

const ImageCard = ({ src, alt }) => {
  return (
    <div className="category-image-card">
      <img src={src} alt={alt} className="cat-img" />
    </div>
  );
};

export default ImageCard;